import { AgentConversation } from '@Models';

export type GroupKey = 'today' | 'yesterday' | 'thisWeek' | 'older';

export interface ConversationGroup {
  key: GroupKey;
  items: AgentConversation[];
}

export const GROUP_I18N_KEY: Record<GroupKey, string> = {
  today: 'Agent.GroupToday',
  yesterday: 'Agent.GroupYesterday',
  thisWeek: 'Agent.GroupThisWeek',
  older: 'Agent.GroupOlder',
};

const ORDER: GroupKey[] = ['today', 'yesterday', 'thisWeek', 'older'];

const MS = {
  day: 24 * 60 * 60 * 1000,
};

const startOfDay = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const bucketFor = (timestamp: string, now: Date): GroupKey => {
  const tsDay = startOfDay(new Date(timestamp)).getTime();
  const todayDay = startOfDay(now).getTime();
  const diffDays = Math.round((todayDay - tsDay) / MS.day);

  if (diffDays <= 0) return 'today';
  if (diffDays === 1) return 'yesterday';
  if (diffDays <= 7) return 'thisWeek';
  return 'older';
};

// Buckets conversations by date; labels resolved at render time via GROUP_I18N_KEY for i18n.
export const groupConversations = (conversations: AgentConversation[], now: Date = new Date()): ConversationGroup[] => {
  const buckets = new Map<GroupKey, AgentConversation[]>(ORDER.map((k) => [k, []]));

  conversations.forEach((c) => {
    const ts = c.timestamps?.last_interaction_at ?? c.timestamps?.updated_at ?? c.timestamps?.created_at;
    if (!ts) {
      buckets.get('older')?.push(c);
      return;
    }
    buckets.get(bucketFor(ts, now))?.push(c);
  });

  return ORDER.filter((key) => (buckets.get(key)?.length ?? 0) > 0).map((key) => ({
    key,
    items: buckets.get(key) ?? [],
  }));
};
